import React from 'react';
import { Calendar } from 'lucide-react';
import dayjs from 'dayjs';

export default function CycleTimeline({ cycleStartDate, cycleEndDate }) {
  if (!cycleStartDate || !cycleEndDate) return null;

  const start = dayjs(cycleStartDate);
  const end = dayjs(cycleEndDate);
  const today = dayjs();

  // Calculate percentage of time elapsed
  const totalDays = end.diff(start, 'day');
  const daysElapsed = today.diff(start, 'day');
  const percentElapsed = Math.min(Math.max((daysElapsed / totalDays) * 100, 0), 100);

  // Calculate days remaining
  const daysRemaining = end.diff(today, 'day');
  const monthsRemaining = Math.floor(daysRemaining / 30);
  const yearsRemaining = Math.floor(daysRemaining / 365);

  // Format time remaining
  let timeRemainingText;
  if (yearsRemaining >= 1) {
    const remainingMonths = Math.floor((daysRemaining % 365) / 30);
    timeRemainingText = `${yearsRemaining} year${yearsRemaining > 1 ? 's' : ''}${remainingMonths > 0 ? `, ${remainingMonths} month${remainingMonths > 1 ? 's' : ''}` : ''} remaining`;
  } else if (monthsRemaining >= 1) {
    timeRemainingText = `${monthsRemaining} month${monthsRemaining > 1 ? 's' : ''} remaining`;
  } else if (daysRemaining > 0) {
    timeRemainingText = `${daysRemaining} day${daysRemaining > 1 ? 's' : ''} remaining`;
  } else {
    timeRemainingText = 'Cycle ended';
  }

  return (
    <div className="mt-4">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <Calendar className="h-4 w-4 text-emerald-600" />
          <span className="font-medium">Cycle Timeline</span>
        </div>
        <span className="text-sm text-gray-600">{timeRemainingText}</span>
      </div>
      
      {/* Timeline bar */}
      <div className="relative h-3 bg-gray-100 rounded-full overflow-hidden">
        <div
          className="absolute top-0 left-0 h-full bg-gradient-to-r from-emerald-400 to-emerald-500 transition-all duration-500 rounded-full"
          style={{ width: `${percentElapsed}%` }}
        />
      </div>

      {/* Date labels */}
      <div className="flex justify-between mt-1.5 text-xs text-gray-500">
        <span>{start.format('MMM D, YYYY')}</span>
        <span>{end.format('MMM D, YYYY')}</span>
      </div>
    </div>
  );
}
